import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-6 py-32 text-center" data-testid="payment-cancel-page">
      <span className="hanko text-muted-foreground text-4xl">止</span>
      <h1 className="font-serif text-4xl mt-6">The purchase was set aside.</h1>
      <p className="mt-4 text-muted-foreground">
        No payment was taken. The Wanderer's path remains open, and every robe can still be earned through verse.
      </p>
      <Link to="/kimono" data-testid="back-to-kimono"
        className="mt-8 inline-block bg-primary text-primary-foreground px-8 py-3 text-sm hover:-translate-y-0.5 transition-transform">
        Back to the Kimono Room
      </Link>
    </div>
  );
}
